// extracted by mini-css-extract-plugin
export default {"vehicle":"AddVehicle_vehicle__P58xO","campos":"AddVehicle_campos__BsVkn","botao":"AddVehicle_botao__4utNk"};